/*global angular*/
var leerlijn = angular.module('leerlijn', []);
leerlijn.directive('leerlijn', ['settings', 'ageRangeManager', function (settings, ageRangeManager) {
  'use strict';
  return {
    restrict: 'E',
    template: require('./leerlijn.html'),
    replace: true,
    transclude: true,
    scope: {
      color: '=',
      developmentStepsBuBao: '=',
      developmentStepsBao: '=',
      openTerm: '=',
      specificForAn: '=',
      showSpecificForAn: '=',
      showToggleButton: '=',
      containerKey: '=',
      showClustersUnder2YearsAnd6Month: '=?'
    },
    link: function (scope, element, attrs) {

      scope.BuBao = settings.BuBao.toString() === 'true';
      scope.showClustersUnder2YearsAnd6Month = scope.showClustersUnder2YearsAnd6Month ? scope.showClustersUnder2YearsAnd6Month : false;
      scope.addClassTimelineWithMoreHeigh = false;
      scope.clustersUnder2YearsAnd6Month = [];
      scope.developmentStepsBaoToShow = [];

      scope.openClustersUnder2YearsAnd6Month = function (open) {
        scope.showClustersUnder2YearsAnd6Month = open;
      };

      scope.showLeerlijnsForAn = function (showAn) {
        scope.showSpecificForAn = showAn;
      };

      scope.$watch(function () {
        let goal;
        if(scope.developmentStepsBao) {
          if(scope.developmentStepsBao[0].leerlijn.goal) {
            goal = scope.developmentStepsBao[0].leerlijn.goal.key;
          } else if (scope.developmentStepsBao[0].leerlijn.content2) {
            goal = scope.developmentStepsBao[0].leerlijn.content2.content1.contentGroup.goal.key;
          } else if (scope.developmentStepsBao[0].leerlijn.content1) {
            goal = scope.developmentStepsBao[0].leerlijn.content1.contentGroup.goal.key;
          }
        }
        return goal;
      }, function (n, o) {

        scope.leerlijnKinds = [];

        if(scope.developmentStepsBao && scope.developmentStepsBao.length > 0) {

          scope.developmentStepsBaoToShow = scope.developmentStepsBao.map((item) => item);

          if (!scope.specificForAn) {

            let clusters = scope.developmentStepsBao.filter((developmentStep) => {
              return developmentStep.type === 'CURRICULUM_ZILL_LEERLIJN_CLUSTER';
            });

            scope.clustersUnder2YearsAnd6Month = clusters.filter((cluster) => {
              return cluster.startage < 2.5;
            }).map((cluster) => {
              cluster.ageRangeText = ageRangeManager.ageRangeToString(cluster.startage, cluster.endage);
              return cluster;
            });

            //we need to hide those from the big list
            if (scope.clustersUnder2YearsAnd6Month.length > 0) {
              let clustersUnder2YearsAnd6MonthKeys = scope.clustersUnder2YearsAnd6Month.map(cluster => cluster.key);
               scope.developmentStepsBaoToShow = scope.developmentStepsBao.filter((developmentStep) => {
                  return !clustersUnder2YearsAnd6MonthKeys.includes(developmentStep.key);
                });
            }
          }


          scope.leerlijnKinds.push({
            title: 'Bao',
            href: '/onderwijssoorten/0c739f2c-2acf-11e5-937b-00ff001a7a08'
          });
        }
        if(scope.developmentStepsBuBao && scope.developmentStepsBuBao.length > 0) {
          scope.leerlijnKinds.push({
            title: 'BuBao',
            href: '/onderwijssoorten/0c739f38-2acf-11e5-937b-00ff001a7a08'
          });
        }

        if(scope.leerlijnKinds.length > 0) {
          scope.leerlijnKind = scope.leerlijnKinds[0];
        }
      }, true);
      let color = '';
      if(scope.developmentStepsBao) {
        if(scope.developmentStepsBao[0].leerlijn.goal) {
          color = scope.developmentStepsBao[0].leerlijn.goal.theme.field.color;
        } else if (scope.developmentStepsBao[0].leerlijn.content2) {
          color = scope.developmentStepsBao[0].leerlijn.content2.content1.contentGroup.goal.theme.field.color;
        } else if (scope.developmentStepsBao[0].leerlijn.content1) {
          color = scope.developmentStepsBao[0].leerlijn.content1.contentGroup.goal.theme.field.color;
        }
      }
      let style = '<style>';
      style = style + '.cd-timeline::before {background: ' + color + ' !important;}';

      if(scope.containerKey) {
        let containerPanel = document.getElementById('container-' + scope.containerKey);
        if (containerPanel.offsetHeight > 48) {
          scope.addClassTimelineWithMoreHeigh = true;
          style = style + '.panel .cd-timelineMoreHeight:before {top: 66px !important;}';
        } else {
          style = style + '.panel .cd-timeline:before {top: 48px !important;}';
        }
        style = style + '.cd-timeline::before {left: 75px;}';
        style = style + '.cd-timeline-block--month {margin-top: 0px !important;}';
      }

      style = style + '.c-hamburger--htx.is-active span::before {background: ' + color + ' !important;}';
      style = style + '.c-hamburger--htx.is-active span::after {background: ' + color + ' !important;}';
      style = style + '</style>';
      element.append(style);
    }
  };
}]);
module.exports = leerlijn;




// WEBPACK FOOTER //
// ./web/js/module/leerlijn/leerlijn.js